module.exports = __webpack_public_path__ + "img/arcs.a7f62fda.jpg";